import { ISection } from '../../../interfaces/scheduler_interfaces';
import { UpdateCalendarSectionTimesCommand } from '../../calendar/commands/update_calendar_section_times_command';
import { UpdateSeatAvailabilityCommand } from '../commands/update_seat_availability_command';
import { RegistrationAlertMessages } from '../types/registration_alert_messages';
import { SchedulerNotificationServant } from '../servants/scheduler_notification_servant';

export class RefreshSeatAvailabilityFacade {
  private refreshSeatsProgressNotification;
  constructor(
    private $timeout: ng.ITimeoutService,
    private updateSeatAvailabilityCommand: UpdateSeatAvailabilityCommand,
    private updateCalendarSectionTimesCommand: UpdateCalendarSectionTimesCommand,
    private ngSchedulerNotificationServant: SchedulerNotificationServant
  ) {}

  refreshSeats(sectionId: ISection['id']) {
    const CLICK_DELAY = 15000;
    this.ngSchedulerNotificationServant.showInfoNotification(RegistrationAlertMessages.PENDING_REFRESH_SEATS_TEXT);
    this.updateSeatAvailabilityCommand([sectionId])
      .then(() => {
        this.ngSchedulerNotificationServant.closeCurrentNotification();
        this.ngSchedulerNotificationServant.showSuccessNotification(
          RegistrationAlertMessages.SUCCESSFUL_REFRESH_SEATS_TEXT
        );
        this.updateSectionTimesAndEnaleRefreshing();
      })
      .catch(() => {
        this.ngSchedulerNotificationServant.showErrorNotification(RegistrationAlertMessages.FAILED_REFRESH_SEATS_TEXT);
      });
    this.$timeout(this.updateSectionTimesAndEnaleRefreshing.bind(this), CLICK_DELAY);
  }

  updateSectionTimesAndEnaleRefreshing() {
    this.updateCalendarSectionTimesCommand();
  }
}

angular.module('capability-ng-scheduler').service('ngRefreshSeatAvailabilityFacade', RefreshSeatAvailabilityFacade);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/facades/refresh_seat_availability_facade.ts